import React, { useState } from "react";
import { X, ExternalLink } from "lucide-react";

// Visor a pantalla completa: imatges amb zoom per toc, PDF en iframe.
export default function DocViewer({ url, onClose }) {
  const [zoom, setZoom] = useState(false);
  if (!url) return null;
  const isPdf = /\.pdf($|\?)/i.test(url);
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[70] flex items-center justify-center overflow-auto bg-black/90 p-2 sm:p-4"
      data-testid="doc-viewer"
    >
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="fixed right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white"
        aria-label="Tancar"
      >
        <X size={22} />
      </button>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="fixed left-4 top-4 z-10 inline-flex items-center gap-1 rounded-full bg-white/20 px-3 py-2 text-xs font-semibold text-white"
      >
        <ExternalLink size={14} /> Obrir original
      </a>
      {isPdf ? (
        <iframe
          onClick={(e) => e.stopPropagation()}
          src={url}
          title="Document"
          className="h-[92vh] w-full max-w-4xl rounded-lg bg-white"
        />
      ) : (
        <img
          src={url}
          alt=""
          onClick={(e) => { e.stopPropagation(); setZoom((z) => !z); }}
          className={zoom ? "max-w-none cursor-zoom-out" : "max-h-full max-w-full cursor-zoom-in rounded-lg object-contain"}
        />
      )}
    </div>
  );
}
